import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/misc-purchase-order/{id}/reject`。body：rejectReason、updatedAt。 */
export async function rejectMiscPurchaseOrder(id, payload) {
  const { data: raw } = await request.post(
    `/srm/misc-purchase-order/${id}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
